import gql from 'graphql-tag';

export const CREATE_LEARNING_PATH = gql`
  mutation learningPath($name: String!, $description: String!, $copiedTemplateId: ID, $modules: [PathModuleInput]!) {
    createLearningPath(
      data: { name: $name, description: $description, modules: $modules, copiedTemplateId: $copiedTemplateId }
    ) {
      success
      code
      message
    }
  }
`;

export const GET_LEARNING_PATH = gql`
  query learningPath($id: ID) {
    learningPath(id: $id) {
      id
      name
      description
      totalRunTime
      modules {
        includeQuiz
        sortOrder
        module {
          id
          description
          title
          publishingStatus
          quiz {
            enabled
          }
        }
      }
    }
  }
`;

export const UPDATE_LEARNING_PATH = gql`
  mutation learningPath($id: ID!, $name: String!, $description: String!, $modules: [PathModuleInput]!) {
    updateLearningPath(id: $id, data: { name: $name, description: $description, modules: $modules }) {
      success
      code
      message
    }
  }
`;

export const GET_INF_LEARNING_TEMPLATE = gql`
  query infLearningTemplate($id: ID) {
    infLearningTemplate(id: $id) {
      id
      name
      description
      totalRunTime
      modules {
        includeQuiz
        sortOrder
        module {
          id
          description
          title
          publishingStatus
          quiz {
            enabled
          }
        }
      }
    }
  }
`;
